import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import httpErrorHandling from '../../../../utils/httpErrorHandling';
import { confirmConfigurationStep } from './configurationRequest';
import { OnboardingStepState } from '../../onboardingSlice';
import { createAppAsyncThunk } from '../../../../common/thunk';
import DashboardService from '../../../../services/dashboard.service';

export const deployNewSubdomain = createAppAsyncThunk(
  'configuration/subdomain',
  async ({ id, subdomain }: { id: string; subdomain: string }) => {
    return await DashboardService.changeSubdomain(id, { subdomain }).then(response => response.data);
  },
);

export interface TemplateState {
  color: string;
  template: string;
}

export interface ConfigurationState {
  template: TemplateState;
  domain: string;
  googleAnalyticsCode: string;
  domainDeploying: boolean;
}

const initialState: ConfigurationState & OnboardingStepState = {
  inProgress: false,
  isDone: false,
  error: '',
  doRedirectFurther: false,
  template: { color: '', template: '' },
  domain: '',
  googleAnalyticsCode: '',
  domainDeploying: false,
};
export const configurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    setConfigurationStateDefault: () => {
      return { ...initialState };
    },
    startProcessingConfiguration: state => {
      state.inProgress = true;
    },
    setTemplate: (state, action: PayloadAction<TemplateState>) => {
      state.template = action.payload;
    },
    setDomain: (state, action) => {
      state.domain = action.payload;
    },
    setCode: (state, action) => {
      state.googleAnalyticsCode = action.payload;
    },
    submitConfiguration: state => {
      state.inProgress = false;
      state.isDone = true;
      state.doRedirectFurther = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(confirmConfigurationStep.fulfilled, state => {
      state.error = '';
      state.doRedirectFurther = true;
    });
    builder.addCase(confirmConfigurationStep.pending, state => {
      state.error = '';
    });
    builder.addCase(confirmConfigurationStep.rejected, (state, action) => {
      state.error = httpErrorHandling(action);
    });
    builder.addCase(deployNewSubdomain.fulfilled, state => {
      state.domainDeploying = true;
    });
    builder.addCase(deployNewSubdomain.rejected, (state, action) => {
      state.error = httpErrorHandling(action);
    });
  },
});

export const { setConfigurationStateDefault, startProcessingConfiguration, setTemplate, setDomain, setCode, submitConfiguration } =
  configurationSlice.actions;

export default configurationSlice.reducer;
